// extracted by mini-css-extract-plugin
export var cardsSection = "M_cz";
export var loanCardList = "M_cx";
export var titleSection = "M_cy";